<!--
 * @Description: 表格更多按钮 按钮数超过props.max  显示更多下拉框
 * @Author: cxh
 * @Date: 2022-05-24 16:25:08
 * @LastEditTime: 2023-03-09 10:40:15
 * @LastEditors: cxh
-->
<template>
  <div :class="[hasMore ? 'more-button-has' : 'more-button', 'flex']" ref="moreButtonRef" style="align-items: center">
    <div :class="['cos-components-moreButton', `cos-components-moreButton-${soltNum}`]">
      <slot></slot>
    </div>
    <a-dropdown class="ant-dropdown-link" overlayClassName="" :trigger="['click']" v-if="hasMore">
      <a class="ant-dropdown-link" @click.prevent> {{ t('btn.more') }} <i class="iconfont icon-danxuanxiala"></i> </a>
      <template #overlay>
        <DcPenetrateContent>
          <a-menu
            :class="['more-button-overlay', `more-button-overlay-${soltNum}`]"
            style="background: rgba(19, 32, 67, 0.9); padding: 10px 0"
          >
            <slot></slot>
          </a-menu>
        </DcPenetrateContent>
      </template>
    </a-dropdown>
  </div>
</template>
<script lang="ts" setup name="MoreButton">
import { ref, getCurrentInstance, ComponentInternalInstance, onUnmounted, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const props = defineProps({
  max: {
    type: Number,
    default: 3
  }
})
// 按钮最大值12 ,显隐判断只有8个
const moreButtonRef = ref()
const { slots } = getCurrentInstance() as ComponentInternalInstance
const hasMore = ref(false)
const soltNum = ref(0)
const observer = ref<any>(null)
const init = () => {
  const slotlength: number = slots?.default?.().length || 0
  if (slotlength < props.max + 1) {
    return
  }
  const btnContent: any = moreButtonRef.value?.getElementsByClassName('cos-components-moreButton')[0]
  if (btnContent) {
    let length = 0
    for (let i = 0; i < btnContent.children.length; i++) {
      if (btnContent.children[i].style.display !== 'none') {
        length++
        if (length === props.max - 1) {
          soltNum.value = i + 1
        }
      }
    }
    if (length > props.max) {
      hasMore.value = true
    } else {
      hasMore.value = false
      soltNum.value = 0
    }
  }
  // 循环取高宽
}
onMounted(() => {
  init()
  setTimeout(() => {
    const btnContent: any = moreButtonRef.value?.getElementsByClassName('cos-components-moreButton')[0]
    if (btnContent) {
      observer.value = new MutationObserver(init)
      observer.value.observe(btnContent, {
        childList: true,
        attributes: true,
        subtree: true
      })
    }
  })
})
onUnmounted(() => {
  observer.value?.disconnect()
})
</script>
<style lang="scss">
.more-button-overlay {
  z-index: 9;
  .ant-btn {
    display: block;
    width: 100%;
    height: auto;
    padding: 8px 28px;
    line-height: 1;
    color: #fff;
    &:hover {
      background: rgba(19, 32, 67, 0.8);
      color: #fff;
    }
  }
}
@for $i from 1 through 8 {
  .more-button-overlay-#{$i} {
    .ant-btn {
      @for $j from 1 through $i {
        &:nth-child(#{$j}) {
          display: none;
        }
      }
    }
  }
  .cos-components-moreButton-#{$i} {
    .ant-btn {
      display: none;
      @for $j from 1 through $i {
        &:nth-child(#{$j}) {
          display: inline-block;
        }
      }
    }
  }
}
</style>
